var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "SessieZoeken session-details-pick-a-date" },
    [
      _c("FullCalendar", {
        ref: "FullCalendar",
        attrs: { options: _vm.calendarOptions },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/calcheck.vue